import NavMenuMobile from './NavMenuMobile';

export default NavMenuMobile;
